import { render, staticRenderFns } from "./DropDownList.vue?vue&type=template&id=70d2ded0"
import script from "./DropDownList.vue?vue&type=script&lang=js"
export * from "./DropDownList.vue?vue&type=script&lang=js"
import style0 from "./DropDownList.vue?vue&type=style&index=0&id=70d2ded0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports